import { render, staticRenderFns } from "./Report_debtor.vue?vue&type=template&id=3fad3f1d&scoped=true&"
import script from "./Report_debtor.vue?vue&type=script&lang=js&"
export * from "./Report_debtor.vue?vue&type=script&lang=js&"
import style0 from "./Report_debtor.vue?vue&type=style&index=0&id=3fad3f1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fad3f1d",
  null
  
)

export default component.exports